/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Axios client settings
 *
 * @file Clients.js
 * @author JP
 * @since 1.0.0
 */

import axios from 'axios';

import EnvConfig from './env/EnvConfig';
import GlsToken from './GlsToken';

export default class Clients {
  constructor() {
    this.env = new EnvConfig().getConfig();
    this.token = GlsToken.get();
  }

  resourceApi = () => {
    const resourceApiAxiosInstance = axios.create({
      baseURL: this.env.GLS_API_BASE_URL,
      timeout: this.env.TIMEOUT,
      headers: {
        appid: this.env.GLS_APP_ID,
        token: this.token
      }
    });

    return resourceApiAxiosInstance;
  };
}
